import React from "react";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "react-feather";
import { Button } from "../../../../ui";

interface PagerProps {
  /** Zero-based current page. */
  currentPage: number;
  totalPages: number;
  /** Zero-based page numbers to show as buttons. */
  pageNumbers: number[];
  onChange: (page: number) => void;
}

/**
 * Page-number pagination built from src/ui buttons. Local to this page until src/ui has one.
 */
const Pager: React.FC<PagerProps> = ({ currentPage, totalPages, pageNumbers, onChange }) => {
  const atStart = currentPage === 0;
  const atEnd = currentPage === totalPages - 1;
  return (
    <nav className="leave-pager" aria-label="Pagination">
      <Button variant="ghost" size="sm" onClick={() => onChange(0)} disabled={atStart} aria-label="First page" icon={<ChevronsLeft size={16} aria-hidden />} />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onChange(currentPage - 1)}
        disabled={atStart}
        aria-label="Previous page"
        icon={<ChevronLeft size={16} aria-hidden />}
      />
      {pageNumbers.map((pageNum) => (
        <Button
          key={pageNum}
          variant={pageNum === currentPage ? "secondary" : "ghost"}
          size="sm"
          className="leave-pager__page ds-num"
          aria-current={pageNum === currentPage ? "page" : undefined}
          onClick={() => onChange(pageNum)}
        >
          {pageNum + 1}
        </Button>
      ))}
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onChange(currentPage + 1)}
        disabled={atEnd}
        aria-label="Next page"
        icon={<ChevronRight size={16} aria-hidden />}
      />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onChange(totalPages - 1)}
        disabled={atEnd}
        aria-label="Last page"
        icon={<ChevronsRight size={16} aria-hidden />}
      />
    </nav>
  );
};

export default Pager;
